import { forwardRef, useEffect, useState, Fragment } from "react";
import { useRouter } from "next/navigation";
import {
  Autocomplete,
  Box,
  Collapse,
  TextField,
  Typography
} from "@mui/material";
import { Virtuoso } from "react-virtuoso";

import { observer, useStore } from "../../../../service/mobx";
import MenuItem from "../../Item";
import { paperSx } from "../..";

export default observer(function SearchMenuTasks() {
  const [open, setOpen] = useState(false);
  const [taskList, setTasks] = useState([]);
  const [options, setOptions] = useState([]);
  const { analytics, bottomSheet, tasks, search } = useStore();
  const router = useRouter();

  useEffect(() => {
    setTasks([...tasks._set]);
  }, [tasks._set]);

  useEffect(() => {
    bottomSheet.set.sx({ height: "65vh" });
  }, [bottomSheet]);

  useEffect(() => {
    setOptions(
      taskList
        .map(task => [task, search.filterTask.has(task) ? "Selected" : "Task"])
        .sort(([task]) => (search.filterTask.has(task) ? -1 : 0))
    );
  }, [taskList, search.filterTask]);

  useEffect(() => {
    setTimeout(setOpen, 500, true);
  }, []);

  return (
    <Autocomplete
      multiple
      disableClearable
      disableCloseOnSelect
      open={open}
      popupIcon={null}
      size="small"
      options={options}
      value={search.filterTaskArray.map(task => [task, "Selected"])}
      groupBy={groupBy}
      onChange={(_, values) => {
        const tasks = values.map(([task]) => task);

        search.updateUrlParams(router, { task: tasks });
        analytics.track.event("Search Filter", {
          entity: { type: "task", value: tasks.length ? tasks : false }
        });
      }}
      getOptionLabel={getOptionLabel}
      renderInput={renderInput}
      noOptionsText={null}
      isOptionEqualToValue={isOptionEqualToValue}
      renderTags={() => null}
      PaperComponent={PaperComponent}
      ListboxComponent={ListboxComponent}
      renderOption={renderOption}
      renderGroup={renderGroup}
      sx={{ minWidth: 280 }}
    />
  );
});

const renderInput = params => (
  <TextField {...params} variant="filled" label="Filter by task" />
);
const isOptionEqualToValue = ([a], [b]) => a === b;
const renderOption = (props, [option], { selected }) => (
  <MenuItem label={option} selected={selected} {...props} key={option} />
);
const groupBy = ([, group]) => group;
const getOptionLabel = ([option]) => option;
const renderGroup = ({ children, group, key }) => (
  <Fragment key={key}>
    <Typography
      gutterBottom
      pl={1.5}
      key={`group-${group}`}
      variant="labelLgProminent"
    >
      {group}
    </Typography>
    {children}
  </Fragment>
);

const ListboxComponent = forwardRef(function ListboxComponent(
  { children, ...props },
  ref
) {
  const itemData = [];

  children.forEach(group => {
    group.props.children.forEach(child => {
      if (Array.isArray(child)) {
        itemData.push(...child);
      } else {
        itemData.push(child);
      }
    });
  });

  return (
    <Box
      ref={ref}
      {...props}
      sx={{
        maxHeight: "unset !important",
        overflow: "hidden !important"
      }}
    >
      <Virtuoso
        overscan={10}
        computeItemKey={computeItemKey}
        data={itemData}
        style={{ height: "49vh" }}
        itemContent={itemContent}
      />
    </Box>
  );
});
const itemContent = (_, data) => data;
const computeItemKey = (_, data) => data.key;
const PaperComponent = forwardRef(function PaperComponent(props, ref) {
  return (
    <Collapse
      appear
      in
      timeout={300}
      sx={{
        ...paperSx,
        boxShadow: { compact: "unset", expanded: paperSx.boxShadow },
        bgcolor: {
          compact: "surface.container.highest",
          expanded: paperSx.bgcolor
        }
      }}
    >
      <div ref={ref} {...props} />
    </Collapse>
  );
});
